import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/bom-families-detail.mdx";

export function BomFamiliesDetailHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
